var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"width":"60%","destroy-on-close":""},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[(_vm.dialogVisible)?_c('video',{staticClass:"video",attrs:{"src":_vm.video,"controls":"","autoplay":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }